import React from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  count: number;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ isOpen, onClose, onConfirm, count }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden border border-slate-200 transform scale-100">
        <div className="p-6 text-center">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4 text-red-600">
                <AlertTriangle size={24} />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">Delete {count} Selected Node{count !== 1 ? 's' : ''}?</h3>
            <p className="text-sm text-slate-500 mb-6">
                This action cannot be undone. Any connections to {count !== 1 ? 'these nodes' : 'this node'} will also be removed.
            </p>
            
            <div className="flex gap-3 justify-center">
                <button 
                    onClick={onClose}
                    className="px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-700 text-sm font-medium hover:bg-slate-50 transition-colors"
                >
                    Cancel
                </button>
                <button 
                    onClick={onConfirm}
                    className="px-4 py-2 bg-red-600 rounded-lg text-white text-sm font-medium hover:bg-red-700 transition-colors flex items-center gap-2 shadow-sm shadow-red-600/20"
                >
                    <Trash2 size={16} /> Delete
                </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;